<section class="sidenav-section devspace-elements-gap" aria-labelledby="dms-heading">
  <header class="section-header">
    <button
      type="button"
      class="section-toggle-button dms-toggle-button"
      (click)="dmsOpen = !dmsOpen"
      [attr.aria-expanded]="dmsOpen"
      aria-controls="dms-content"
    >
      <svg
        class="section-toggle-arrow"
        aria-hidden="true"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1248 17.875L10.8748 14.625C10.479 14.2292 10.3907 13.7762 10.6098 13.2662C10.8282 12.7554 11.2186 12.5 11.7811 12.5H18.2186C18.7811 12.5 19.1715 12.7554 19.3898 13.2662C19.609 13.7762 19.5207 14.2292 19.1248 14.625L15.8748 17.875C15.7498 18 15.6144 18.0937 15.4686 18.1562C15.3227 18.2187 15.1665 18.25 14.9998 18.25C14.8332 18.25 14.6769 18.2187 14.5311 18.1562C14.3852 18.0937 14.2498 18 14.1248 17.875Z"
          fill="currentColor"
        />
      </svg>
      <svg
        class="section-title-icon"
        aria-hidden="true"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.85 17.1C6.7 16.45 7.65 15.9373 8.7 15.562C9.75 15.1873 10.85 15 12 15C13.15 15 14.25 15.1873 15.3 15.562C16.35 15.9373 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1877 15.6417 19.513 14.775C19.8377 13.9083 20 12.9833 20 12C20 9.78333 19.221 7.89567 17.663 6.337C16.1043 4.779 14.2167 4 12 4C9.78333 4 7.896 4.779 6.338 6.337C4.77933 7.89567 4 9.78333 4 12C4 12.9833 4.16267 13.9083 4.488 14.775C4.81267 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1873 12.6627 9.512 11.988C8.83733 11.3127 8.5 10.4833 8.5 9.5C8.5 8.51667 8.83733 7.68733 9.512 7.012C10.1873 6.33733 11.0167 6 12 6C12.9833 6 13.8127 6.33733 14.488 7.012C15.1627 7.68733 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1627 11.3127 14.488 11.988C13.8127 12.6627 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.871 14.5 19.613C15.2833 19.3543 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6457 14.5 17.387C13.7167 17.129 12.8833 17 12 17C11.1167 17 10.2833 17.129 9.5 17.387C8.71667 17.6457 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3543 9.5 19.613C10.2833 19.871 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z"
          fill="currentColor"
        />
      </svg>
      <h3 id="dms-heading" class="section-title-text">Direktnachrichten</h3>
      <span *ngIf="totalUnread > 0" class="dm-total-badge">{{ totalUnread }}</span>
    </button>
  </header>

  @if (dmsOpen) {
  <div id="dms-content" class="section-content-wrapper devspace-elements-gap">
    <ul class="item-list" role="list">
      @for(u of visibleUsers; track u.uid) {
      <a
        class="contact-item-anker"
        [routerLink]="['/workspace/dm', calculateDmId(u)]"
        routerLinkActive="is-active"
      >
        <li class="contact">
          <app-contact-item
            (click)="viewStateService.currentView = 'chat'"
            [meUid]="meUid"
            [user]="u"
            (contactClick)="ensureDmExists($event)"
          ></app-contact-item>
        </li>
      </a>
      }
    </ul>

    @if (hiddenCount > 0) {
    <button type="button" class="load-more-button" (click)="loadMore()">
      <span class="more-pill">+{{ hiddenCount }}</span>
      <span class="name">weitere anzeigen</span>
    </button>
    }
  </div>
  }
</section>
